// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11gaX","content":"styles_content__2l21y","tableWrap":"styles_tableWrap__2Y8Ak"};